import { useState } from 'react';
import { useSelector } from 'react-redux';
import useDebounce from './useDebounce';
import usePreferencesInit from './usePreferencesInit';

const useDataGridVisibility = (visibleColumns = {}, updatePreferences = false, preferenceName) => {

    const system_preferences = useSelector((state) => state.dashboardReducer?.system_preferences?.data?.agent);
    const preferencesInit = usePreferencesInit('agent', system_preferences, false);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState(visibleColumns);


    const {fetch} = useDebounce(1000);


    const handleVisibilityChange = (newModel) => {
        setColumnVisibilityModel(newModel);
        if(updatePreferences){
            fetch({ }, (results) => {
                let keys = Object.keys(newModel).filter(key => newModel[key] === false);
                const newValue = keys.join(", ");
                preferencesInit.pageLogic.handleUpdate(preferenceName, newValue.trim());
            });
        }
    }

    return {
        columnVisibilityModel,
        onColumnVisibilityModelChange: handleVisibilityChange
    }
}

export default useDataGridVisibility;